import { SignUpAppEntryComponent } from "../../features/signUp/signUpAppEntry/signup-app-entry.component";

import { CoreModule } from "../../../common/modules/core/core.module";
import { ConsoleService } from "../../../common/services/console/console.service";
import { LocalizationService } from "../../../common/services/localization.service";
import { LogTarget } from "../../../common/services/logging/log.target";
import { cons, consoleLogTarget } from "../app.config";
import { APP_NAME } from "../app-name";

import { ApplicationConfig, Component, importProvidersFrom, LOCALE_ID } from "@angular/core";
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { CustomReuseStrategy } from "../phone/customReuseStrategy";
import {
  provideRouter,
  RouteReuseStrategy,
  withHashLocation,
  withRouterConfig
} from "@angular/router";

// i18n mobile translations imports
import { CustomTranslateLoader } from "../../i18n/translate-loader";

// for AoT compilation
export function LoaderFactory() {
  return new CustomTranslateLoader();
}

import { SignUpIdentityService } from "./signupIdentity.service";
import { ApiSessionService } from "../../../common/services/api/api-session.service";
import { IdentityService } from "../../../common/services/identity.service";
import { NetworkService } from "../../../common/services/network.service";
import { WebNetworkService } from "../../features/shared/services/webNetwork/web-network.service";
import { SignUpLifeCycleHookApiResource } from "./api/signup-lifecycle-hook-api-resource";
import { SignupRoutes } from "./signup-app-routing";
import { RouteExtraOptions } from "../routing-helper";

@Component({
  selector: "onsip-signup-app",
  template: "<onsip-signup-app-entry></onsip-signup-app-entry>",
  imports: [SignUpAppEntryComponent]
})
export class SignupAppComponent {}

export const SignupConfig: ApplicationConfig = {
  providers: [
    { provide: APP_NAME, useValue: "signup" },
    { provide: ApiSessionService, useClass: ApiSessionService },
    { provide: IdentityService, useClass: SignUpIdentityService },
    { provide: NetworkService, useClass: WebNetworkService },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    {
      provide: LOCALE_ID,
      deps: [LocalizationService],
      useFactory: (localizationService: LocalizationService) => localizationService.getLocale()
    },
    importProvidersFrom(
      CoreModule.forRoot([
        { provide: ConsoleService, useFactory: cons },
        { provide: LogTarget, useFactory: consoleLogTarget, deps: [ConsoleService], multi: true }
      ])
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: LoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    SignUpLifeCycleHookApiResource(),
    provideRouter(SignupRoutes, withRouterConfig(RouteExtraOptions), withHashLocation()),
    provideHttpClient(withInterceptorsFromDi(), withXhr())
  ]
};
